import React from "react";

export const AuroraBackground = ({ variant = "hero", className = "" }) => {
  const blobs = {
    hero: [
      { cls: "violet", style: { width: 700, height: 700, top: "-200px", left: "-180px" } },
      { cls: "cyan", style: { width: 600, height: 600, top: "10%", right: "-180px" } },
      { cls: "rose", style: { width: 500, height: 500, bottom: "-180px", left: "20%" } },
      { cls: "gold", style: { width: 380, height: 380, top: "40%", left: "40%" } },
    ],
    soft: [
      { cls: "violet", style: { width: 500, height: 500, top: "-160px", left: "10%" } },
      { cls: "cyan", style: { width: 450, height: 450, bottom: "-160px", right: "5%" } },
    ],
    gold: [
      { cls: "gold", style: { width: 600, height: 600, top: "10%", left: "30%" } },
      { cls: "rose", style: { width: 400, height: 400, bottom: "-160px", right: "10%" } },
    ],
  };
  const set = blobs[variant] || blobs.soft;
  return (
    <div className={`aurora-layer ${className}`} aria-hidden="true">
      {set.map((b, i) => (
        <span key={`${variant}-${b.cls}-${i}`} className={`aurora-blob ${b.cls}`} style={b.style} />
      ))}
      <span className="grain" />
    </div>
  );
};
